import { Injectable } from '@angular/core';
import { ChatNotificationData, chatThreadKey } from '../utils/chat-notification-url';

@Injectable({ providedIn: 'root' })
export class ChatOpenRegistryService {
  private openThreads = new Set<string>();

  register(data: ChatNotificationData): void {
    const key = chatThreadKey(data);
    if (key) {
      this.openThreads.add(key);
    }
  }

  unregister(data: ChatNotificationData): void {
    const key = chatThreadKey(data);
    if (key) {
      this.openThreads.delete(key);
    }
  }

  clear(): void {
    this.openThreads.clear();
  }

  isSuppressed(data: ChatNotificationData): boolean {
    const key = chatThreadKey(data);
    return key ? this.openThreads.has(key) : false;
  }
}
